import styled from 'styled-components'

import { theme } from '../../styles/theme'

export const Container = styled.div`
  width: 100%;
  border-bottom: 1px solid ${theme.colors.gray400};
  padding-bottom: 16px;
  margin-bottom: 16px;

  position: relative;

  display: flex;
`

export const Image = styled.img`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  margin-right: 16px;

  object-fit: cover;
`

export const ChatDescription = styled.div`
  display: flex;
  flex-direction: column;
`

export const ChatTitle = styled.div`
  font-size: ${theme.font.sizes.small};
  font-weight: ${theme.font.bold};
  color: ${theme.colors.black};
`

export const LastMessage = styled.div`
  font-size: ${theme.font.sizes.xsmall};
  font-weight: ${theme.font.normal};
  color: ${theme.colors.gray600};

  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`

export const LastMessageDate = styled.div`
  font-size: ${theme.font.sizes.xsmall};
  font-weight: ${theme.font.normal};
  color: ${theme.colors.gray400};

  text-align: right;

  align-self: flex-start;
  margin-left: auto;
`

export const RedCircle = styled.div`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: ${theme.colors.erro};

  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
`
